import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=9260d06c&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=9260d06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9260d06c",
  null
  
)

export default component.exports